import { useCheckPermissions } from '@/shared';
import { SaveCausalIncidente } from '../../shared/components/SaveCausalIncidente';
import { PermissionsEnum } from '@/auth/interfaces';

export interface CrearCausalIncidentePageInterface {}

const CrearCausalIncidentePage: React.FC<CrearCausalIncidentePageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_categoria_producto)
  return <SaveCausalIncidente titlePage="Crear Causal Incidencia" />;
};

export default CrearCausalIncidentePage;
